import React from 'react';

/**
 * PageConfig component for GuiBuilder
 * Contains page title and description inputs
 */
export default function PageConfig({
    pages,
    activePageIndex,
    updatePageField,
    flowMode = 'processLine'
}) {
    const activePage = pages[activePageIndex];
    const titleLabel = flowMode === 'tabs'
        ? 'Tab title'
        : flowMode === 'accordions'
            ? 'Accordion title'
            : flowMode === 'allInOne'
                ? 'Section title'
                : 'Step title';

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '1rem', background: 'var(--bg-secondary)', padding: '1rem', border: '1px solid var(--border)', borderRadius: '6px' }}>
            <div>
                <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-secondary)', display: 'block', marginBottom: '0.25rem' }}>{titleLabel}</label>
                <input 
                    type="text" 
                    className="input-field" 
                    style={{ margin: 0, padding: '0.4rem', fontSize: '0.85rem' }} 
                    value={activePage?.title || ''}
                    onChange={e => updatePageField(activePageIndex, 'title', e.target.value)}
                    placeholder="Page title"
                />
            </div>
            <div>
                <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-secondary)', display: 'block', marginBottom: '0.25rem' }}>PAGE SUBTITLE / INSTRUCTIONS</label>
                <input 
                    type="text" 
                    className="input-field" 
                    style={{ margin: 0, padding: '0.4rem', fontSize: '0.85rem' }} 
                    value={activePage?.description || ''}
                    onChange={e => updatePageField(activePageIndex, 'description', e.target.value)}
                    placeholder="Provide helpful context here"
                />
            </div>
        </div>
    );
}
